import api from "api/axios";

const BASE = "/admin/consent-templates";

export const getConsentTemplates = (params) => api.get(BASE, { params });

export const getConsentTemplateMeta = () => api.get(`${BASE}/meta`);

export const getConsentTemplate = (id, params) =>
  api.get(`${BASE}/${id}`, { params });

export const createConsentTemplate = (payload) => api.post(BASE, payload);

export const updateConsentTemplate = (id, payload) =>
  api.put(`${BASE}/${id}`, payload);

export const saveConsentTemplateDesign = (id, payload) =>
  api.put(`${BASE}/${id}/design`, payload);

export const saveConsentTemplateTarget = (id, target) =>
  api.put(`${BASE}/${id}/target`, { target });

export const publishConsentTemplate = (id) => api.post(`${BASE}/${id}/publish`);

export const duplicateConsentTemplate = (id, payload = {}) =>
  api.post(`${BASE}/${id}/duplicate`, payload);

export const setConsentTemplateStatus = (id, status) =>
  api.patch(`${BASE}/${id}/status`, { status });

export const deleteConsentTemplate = (id) => api.delete(`${BASE}/${id}`);

export const getConsentTemplateVersions = (id) =>
  api.get(`${BASE}/${id}/versions`);

export const createConsentTemplateVersion = (id, payload = {}) =>
  api.post(`${BASE}/${id}/versions`, payload);

export const restoreConsentTemplateVersion = (id, version) =>
  api.post(`${BASE}/${id}/versions/${version}/restore`);
